import React from 'react';
import { useParams } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import Layout from '../components/Layout';
import NotFound from './NotFound';
import { useApp } from '../context/AppContext';
import { staticPages } from '../mock/pages';
import useSEO from '../hooks/useSEO';

const StaticPage = ({ slugProp }) => {
  const { slug: slugParam } = useParams();
  const slug = slugProp || slugParam;
  const { lang } = useApp();
  const page = staticPages[slug];
  const c = page ? (page[lang] || page.en) : null;
  useSEO(c ? `${c.title} | CAB.TAXI` : 'CAB.TAXI', c ? c.intro : '', { skip: !page });

  if (!page) return <NotFound />;

  return (
    <Layout>
      <section className="bg-[color:var(--brand-dark)] text-white py-16" data-testid={`static-hero-${slug}`}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-xs font-semibold tracking-wide uppercase mb-5">
            <Sparkles className="w-3.5 h-3.5" style={{ color: 'var(--brand-accent)' }} /> CAB.TAXI
          </div>
          <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight">{c.title}</h1>
          <p className="mt-4 text-white/70 leading-relaxed max-w-2xl">{c.intro}</p>
        </div>
      </section>
      <section className="py-14">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 space-y-8">
          {c.sections.map((s, i) => (
            <div key={i} className="border-l-2 pl-5" style={{ borderColor: 'var(--brand-accent)' }} data-testid={`static-section-${slug}-${i}`}>
              <h2 className="text-lg font-extrabold text-[color:var(--brand-dark)]">{s.h}</h2>
              <p className="mt-2 text-gray-600 leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
};

export default StaticPage;
